import routes from './stepLearningGoalsRoutes';

import StepLearningGoalsService from './services/stepLearningGoalsService';

import StepLearningGoalsComponent from './stepLearningGoalsComponent';
import SubjectAreaComponent from './pages/subjectArea/subjectAreaComponent';
import OtherTabComponent from './pages/otherTab/otherTabComponent';

const StepLearningGoalsModule = angular.module('app.stepLearningGoals', [])
    .config(routes)
    .component('stepLearningGoals', StepLearningGoalsComponent)
    .component('subjectArea', SubjectAreaComponent)
    .component('otherTab', OtherTabComponent)
    .service('StepLearningGoalsService', StepLearningGoalsService);

export default StepLearningGoalsModule;



// WEBPACK FOOTER //
// ./src/app/pages/evaluation/pages/stepLearningGoals/index.js